import { useState } from "react";
import * as Styles from "../CustomTable.styles";
import CustomIcon from "../../CustomIcon/CustomIcon";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
interface CustomTableEditableCellProps {
  align?: "left" | "center" | "right";
  value: string | undefined;
  onChange?: (value: string) => void;
  isEditAllowed?: boolean;
}

export default function CustomTableEditableCell({ value, align = "left", onChange, isEditAllowed = true }: CustomTableEditableCellProps) {
  const initialValue = value ?? "";
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState(initialValue);

  function finishEdit(confirm: boolean) {
    if (!onChange) return;

    if (confirm && localValue.trim() !== "") {
      onChange(localValue);
    } else {
      setLocalValue(initialValue);
    }

    setIsEditing(false);
  }

  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") finishEdit(true);
    if (e.key === "Escape") finishEdit(false);
  }

  return (
    <Styles.CustomEditableTableCell
      align={align}
      onClick={() => {
        if (!isEditAllowed) return;
        setIsEditing(true);
      }}
    >
      {isEditing && isEditAllowed ? (
        <Styles.CustomEditableCellInput
          autoFocus
          value={localValue}
          onChange={(event) => setLocalValue(event.target.value)}
          onBlur={() => finishEdit(true)}
          onKeyDown={handleKeyDown}
        />
      ) : (
        <Styles.CustomEditableCellDisplayValueContainer>
          <Styles.CustomEditableCellDisplayValueContent>
            {value}
            {isEditAllowed && <CustomIcon Icon={EditRoundedIcon} size="var(--icon-size-sm)" />}
          </Styles.CustomEditableCellDisplayValueContent>
        </Styles.CustomEditableCellDisplayValueContainer>
      )}
    </Styles.CustomEditableTableCell>
  );
}
